<template>
    <button @click="clicked()" :class="this.type" :style="customStyles">
        <div class="wrapper">
            <span v-if="typeof icon !== 'undefined' && icon !== ''" :class="['icon', icon]"></span>
            <span>{{title}}</span>
        </div>
    </button>
</template>

<script>
    export default {
        name: "SubmitButton",
        props: {
            title: {
                type: String,
                required: true
            },
            type: {
                type: String,
                required: true,
                default: 'button'
            },
            icon: {
                type: String,
                required: false
            },
            customStyles: {
                type: String
            }
        },
        methods: {
            clicked: function () {
                this.$emit('click');
            },
            getImgUrl: function (pic) {
                return require('../../assets/' + pic)
            }
        }
    }

</script>

<style lang="scss" scoped>
    a {
        text-decoration: none;
    }

    button {
        font-size: 14px;
        padding: 0.3em;
        min-width: 10em;
        cursor: pointer;
        display: flex;
        align-items: center;
        color: #fff;
    }

    button:focus {
        outline: 0;
    }

    .wrapper {
        height: 100%;
        display: flex;
        align-items: center;
        text-align: center;
        margin: auto;
    }

    .icon {
        margin-right: .5em;
    }

    .createButton {
        background-color: $pink;
        border-color: $pink;
        border-radius: 5px;
        border-style: solid;
        text-transform: uppercase;
        padding: .5em .7em .5em .7em;
    }

    .large {
        padding: 0.9em 3em;
        font-size: 0.85em;
    }

    .grey {
        background-color: $darkGrey;
        border-color: $darkGrey;
    }

    .large .icon {
        font-size: 1.3em;
        font-weight: lighter;
    }

    .fullWidthButton {
        color: $pink;
        width: 100%;
        background-color: #fff;
        border: none;
        padding: 1em;
    }

    .fullWidthButton .icon {
        font-size: 1.3rem !important;
    }

    .fullWidthButton span {
        color: inherit;
        font-size: 17px;
        font-weight: bold;
    }

    .fullWidthButton:hover {
        color: #fff;
    }

    .fullWidthButton:hover {
        background-color: $pink;
    }

</style>